import { render, staticRenderFns } from "./content1.vue?vue&type=template&id=247b5d42&"
import script from "./content1.vue?vue&type=script&lang=js&"
export * from "./content1.vue?vue&type=script&lang=js&"
import style0 from "./content1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports